import api from '../utils/api'
import moment from 'moment'
import qs from 'qs'
import _ from 'lodash'

import { SET_FEATURED_ITEMS } from '../constants/actionTypes'

import { normalizeFeatured, normalizeExperiences } from '../utils/normalization'

export function setFeatured(featuredItems) {
  return { type: SET_FEATURED_ITEMS, featuredItems }
}

export function getFeatured() {
  return dispatch => {
    api(`featured/home_page?reset_cache=t`)
      .then(response => {
        const json = response.data
        if (json.is_success) {
          dispatch(setFeatured(normalizeFeatured(json)))
        } else {
          // console.log(json.error);
        }
      })
      .catch(e => console.log(e)) /* eslint-disable-line no-console */
  }
}

// Action for upcoming experiences - using same approach as main experiences page
export function getUpcomingExperiences(filter = {}) {
  return dispatch => {
    // Use same date format as main experiences page
    const startDate = moment().toString()  // Current time as full ISO string
    const endDate = filter.endDate ? moment(filter.endDate).toString() : null
    
    const address = filter.address ? filter.address.map(add => add.value) : []
    const cuisineTypes = filter.cuisineTypes ? filter.cuisineTypes.map(cuisine => cuisine.label) : []

    return api('search/experiences', {
      params: {
        page: filter.current_page || 1,
        per_page: filter.per_page || 21,
        locations: address,
        cuisine_types: cuisineTypes,
        date_range: {
          start_date: startDate,
          end_date: endDate
        }
      },
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })
      .then(response => {
        const json = response.data
        
        if (json.meta && json.meta.is_success) {
          // Use same approach as main experiences page - minimal filtering
          const experiences = _.uniqBy(json.experiences, 'id')
          
          // Normalize the experiences data
          const normalizedExperiences = normalizeExperiences(experiences)
          
          dispatch({
            type: 'SET_UPCOMING_EXPERIENCES',
            upcomingExperiences: normalizedExperiences
          })
          return json
        } else {
          console.error('Failed to fetch upcoming experiences:', json)
          return json
        }
      })
      .catch(error => {
        console.error('Error fetching upcoming experiences:', error)
        throw error
      })
  }
}
